import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { WelcomeDialogComponent } from './welcome-dialog.component';

// PrimeNG Imports
import { StepperModule } from 'primeng/stepper';
import { DialogModule } from 'primeng/dialog';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { MessageModule } from 'primeng/message';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { InputText } from 'primeng/inputtext';
import { NgxMaskDirective } from 'ngx-mask';
import { ListboxModule } from 'primeng/listbox';
import { DividerModule } from 'primeng/divider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SharedModule } from '../../shared/shared.module';
import { CheckboxModule } from 'primeng/checkbox';


@NgModule({
  declarations: [
    WelcomeDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule,
    StepperModule,
    DialogModule,
    ScrollPanelModule,
    MessageModule,
    ButtonModule,
    TableModule,
    CardModule,
    InputText,
    DividerModule,
    ListboxModule,
    RadioButtonModule,
    NgxMaskDirective,
    SharedModule,
    CheckboxModule
  ],
  exports: [
    WelcomeDialogComponent
  ]
})
export class WelcomeDialogModule { } 